import React from "react";
import { cn } from "@/helpers/classNames";

type LoaderProps = React.HTMLAttributes<SVGElement>;

const Loader: React.FC<LoaderProps> = ({ className = undefined, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    className={cn("animate-spin", className)}
    {...props}
  >
    <circle
      cx="8"
      cy="8"
      r="7.25"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeDashoffset="-10"
      strokeDasharray="48,64"
      className="animate-[dash_1.5s_ease-in-out_infinite]"
    />
  </svg>
);

export default Loader;
